/* eslint-disable max-len */
import 'react';

const StarFillSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path
                d="M11.902 4.435c.255.023.304.073.33.136h0l1.439 3.554a1.749 1.749 0 001.498 1.089h0l3.825.27a.25.25 0 01.143.44h0l-2.935 2.467a1.749 1.749 0 00-.573 1.762h0l.925 3.721a.25.25 0 01-.375.272h0l-3.253-2.029a1.749 1.749 0 00-1.852 0h0l-3.253 2.03a.25.25 0 01-.375-.273h0l.925-3.72a1.749 1.749 0 00-.573-1.763h0L4.863 9.925a.25.25 0 01.143-.441h0l3.825-.27a1.749 1.749 0 001.498-1.09h0l1.44-3.553a.25.25 0 01.133-.136z"
                fill="#FFB652"
                fillRule="nonzero"
                stroke="#FFB652"
                strokeWidth="1.5"
            />
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
export default StarFillSvg;
